module.exports = __webpack_public_path__ + "assets/img/3008.b03961a6.png";